import { useState } from "react";
import { Badge } from "antd";
import { StatusTable } from "./StatusTable";
import { SEMAFORO_COLORS } from "../constants";

export const StatusCard = ({ nombre, servicios, reglas, total }) => {
  const [filtro, setFiltro] = useState(null);

  const colorMap = {
    rojo: { color: SEMAFORO_COLORS.red, class: "semaforo__rojo" },
    amarillo: { color: SEMAFORO_COLORS.yellow, class: "semaforo__amarillo" },
    verde: { color: SEMAFORO_COLORS.green, class: "semaforo__verde" },
  };

  const contadores = {
    rojo: servicios.filter((s) => s.colorClass === colorMap.rojo.class).length,
    amarillo: servicios.filter((s) => s.colorClass === colorMap.amarillo.class).length,
    verde: servicios.filter((s) => s.colorClass === colorMap.verde.class).length,
  };

  const serviciosFiltrados = filtro
    ? servicios.filter((s) => s.colorClass === filtro)
    : servicios;

  const handleBadgeClick = (color) => {
    setFiltro(filtro === color ? null : color);
  };

  return (
    <div className="semaforo-dinamico__container">
      <div className="semaforo-dinamico__header">
        <h2 className="semaforo-dinamico__title">
          {nombre}
          <Badge
            count={contadores.rojo}
            color={colorMap.rojo.color}
            style={{ cursor: "pointer", opacity: filtro === colorMap.rojo.class ? 1 : 0.6 }}
            onClick={() => handleBadgeClick(colorMap.rojo.class)}
            title="Click para filtrar por rojo"
          />
          <Badge
            count={contadores.amarillo}
            color={colorMap.amarillo.color}
            style={{ cursor: "pointer", opacity: filtro === colorMap.amarillo.class ? 1 : 0.6 }}
            onClick={() => handleBadgeClick(colorMap.amarillo.class)}
            title="Click para filtrar por amarillo"
          />
          <Badge
            count={contadores.verde}
            color={colorMap.verde.color}
            style={{ cursor: "pointer", opacity: filtro === colorMap.verde.class ? 1 : 0.6 }}
            onClick={() => handleBadgeClick(colorMap.verde.class)}
            title="Click para filtrar por verde"
          />
        </h2>
      </div>
      <StatusTable servicios={serviciosFiltrados} reglas={reglas} />
    </div>
  );
};
